// Dual-pad POS: the master pad keeps cart, categories and checkout; the slave pad shows the first products
// of the master's category and sends taps back. Both join one pair room on the POS WebSocket server.
(function () {
  const DUAL_TAP_ACK_TIMEOUT = 1500;
  const DUAL_PING_INTERVAL = 10000;
  const DUAL_PONG_TIMEOUT = 25000;
  const DUAL_ALL_CATEGORY = 'all';
  const DUAL_MAX_PAGES = 100;

  $(document).ready(function () {
    const $pos = $('#classic-location-products');
    if ($('body').attr('p') !== 'events' || !$pos.length) {
      return;
    }

    const role = $pos.attr('data-dual-role');
    if (role === 'master' || role === 'slave') {
      // Header styles: the header is outside the POS container (see _dualScreen.scss)
      $('body').addClass('dual-screen-' + role);
    }
    let messages = {};
    try {
      messages = JSON.parse($pos.attr('data-dual-messages') || '{}');
    } catch (e) {
      messages = {};
    }

    if (role === 'master') {
      initDualMaster($pos, messages);
    } else if (role === 'slave') {
      initDualSlave($pos, messages);
    }
  });

  /**
   * One WebSocket per pad for the pair room, separate from the customer screen socket.
   * A fresh token is fetched on every (re)connect.
   */
  function createDualConnection(handlers) {
    let socket = null;
    let joined = false;
    let stopped = false;
    let lastSeen = 0;
    let pingTimer = null;
    let reconnectTimer = null;
    let reconnectDelay = 1000;

    function socketUrl() {
      const hostname = window.location.hostname;
      return location.protocol === 'https:'
        ? `wss://${hostname}/ws`
        : `ws://${hostname}:9090/`;
    }

    function connect() {
      if (stopped) {
        return;
      }
      $.ajax({
        type: 'GET',
        url: '/api/v1/private/dual-screen/connection',
        cache: false,
      })
        .done(function (data) {
          if (!data || !data.token) {
            handlers.onUnpaired(data || {});
            return;
          }
          handlers.onInfo(data);
          open(data.token);
        })
        .fail(function (xhr) {
          if (xhr.responseJSON && xhr.responseJSON.redirect_url) {
            return;
          }
          scheduleReconnect();
        });
    }

    function open(token) {
      const ws = new WebSocket(socketUrl());
      socket = ws;
      lastSeen = Date.now();

      ws.onopen = function () {
        ws.send(JSON.stringify({ type: 'dual.hello', token: token }));
        startPing();
      };

      ws.onmessage = function (event) {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          return;
        }
        if (!data || typeof data.type !== 'string' || data.type.indexOf('dual.') !== 0) {
          return;
        }
        lastSeen = Date.now();

        if (data.type === 'dual.pong') {
          return;
        }
        if (data.type === 'dual.welcome') {
          joined = true;
          reconnectDelay = 1000;
        }
        if (data.type === 'dual.replaced') {
          // Another tab or a reload of this pad took over the pair room
          stopped = true;
        }
        if (data.type === 'dual.error') {
          if (data.code === 'invalid_token' || data.code === 'not_joined') {
            drop();
          }
          return;
        }
        handlers.onMessage(data);
      };

      ws.onclose = function () {
        if (socket === ws) {
          drop();
        }
      };
    }

    // Forget the socket at once (a dead network can delay onclose by minutes) and reconnect
    function drop() {
      const ws = socket;
      socket = null;
      joined = false;
      stopPing();
      if (ws) {
        ws.onclose = null;
        ws.onmessage = null;
        try {
          ws.close();
        } catch (e) {}
      }
      handlers.onDisconnected();
      scheduleReconnect();
    }

    function scheduleReconnect() {
      if (stopped || reconnectTimer) {
        return;
      }
      reconnectTimer = setTimeout(function () {
        reconnectTimer = null;
        connect();
      }, reconnectDelay);
      reconnectDelay = Math.min(reconnectDelay * 2, 10000);
    }

    function startPing() {
      stopPing();
      pingTimer = setInterval(function () {
        if (Date.now() - lastSeen > DUAL_PONG_TIMEOUT) {
          drop();
          return;
        }
        send({ type: 'dual.ping' });
      }, DUAL_PING_INTERVAL);
    }

    function stopPing() {
      if (pingTimer) {
        clearInterval(pingTimer);
        pingTimer = null;
      }
    }

    function send(message) {
      if (!socket || socket.readyState !== WebSocket.OPEN || !joined) {
        return false;
      }
      socket.send(JSON.stringify(message));
      return true;
    }

    return { connect: connect, send: send };
  }

  // Helpers shared by master and slave; the slave's grid is the same server-rendered markup as the master's

  function dualActiveCategoryId() {
    const $active = $('.tablinks.active').first();
    return $active.length ? String($active.attr('data-category-id')) : DUAL_ALL_CATEGORY;
  }

  function dualPane(categoryId) {
    return $('#category-tabcontent-' + categoryId + ' #category-' + categoryId);
  }

  function dualTiles($pane) {
    return $pane.children('.shop-product-container');
  }

  function dualTileKey($tile) {
    const productId = $tile.attr('data-product-id');
    if (productId) {
      return 'p' + productId;
    }
    const subCategoryId = $tile.find('.sub_product_category_card_btn').attr('data-sub-product-category-id');
    return subCategoryId ? 's' + subCategoryId : '';
  }

  // Every product of a category in one list: the POS endpoint is paginated, so read page
  // after page until a page adds nothing new or fails. Resolves with the tiles' HTML.
  function dualLoadAllProducts(categoryId) {
    const seen = {};
    let html = '';
    let pageSize = 0;

    function loadPage(page) {
      const formData = new FormData();
      formData.append('page', page);
      formData.append('search_string', '');
      formData.append('category_id', categoryId);
      formData.append('location_id', $('#location-id').val());
      return $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/get-category-products',
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then(function (data) {
        let added = 0;
        const $tiles = $('<div>')
          .html((data && data.products_html) || '')
          .children('.shop-product-container');
        pageSize = pageSize || $tiles.length;
        $tiles.each(function () {
          const key = dualTileKey($(this));
          if (key && !seen[key]) {
            seen[key] = true;
            html += this.outerHTML;
            added++;
          }
        });
        // A short page is the last one
        if (added === 0 || $tiles.length < pageSize || page >= DUAL_MAX_PAGES) {
          return html;
        }
        return loadPage(page + 1);
      }, function () {
        // Past the last page the endpoint answers with an error: keep what was loaded
        return html;
      });
    }

    return loadPage(1);
  }

  function dualUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  /**
   * Master: shows every product itself, sends its screen state to the slave, and runs slave taps
   * through the normal add-to-cart handler so every cart rule still applies.
   */
  function initDualMaster($pos, messages) {
    let locked = false;
    let slaveHidden = false;
    let lastSentState = '';
    try {
      slaveHidden = localStorage.getItem('dualScreenSlaveHidden') === '1';
    } catch (e) {}
    const handledTapIds = [];

    const connection = createDualConnection({
      onInfo: function () {},
      onUnpaired: function () {},
      onMessage: function (data) {
        switch (data.type) {
          case 'dual.welcome':
          case 'dual.peer':
          case 'dual.request_state':
            sendState(true);
            break;
          case 'dual.tap':
            handleTap(data);
            break;
        }
      },
      onDisconnected: function () {},
    });

    function buildState() {
      return {
        type: 'dual.state',
        locationId: String($('#location-id').val()),
        posUrl: window.location.pathname + window.location.search,
        categoryId: dualActiveCategoryId(),
        locked: locked,
        hidden: slaveHidden,
      };
    }

    function sendState(force) {
      const state = buildState();
      const json = JSON.stringify(state);
      if (!force && json === lastSentState) {
        return;
      }
      if (connection.send(state)) {
        lastSentState = json;
      }
    }

    function refresh(force) {
      sendState(force);
    }

    function cartSnapshot() {
      try {
        if (typeof locationCart === 'undefined' || !locationCart) {
          return '';
        }
        return [
          locationCart.number_of_products,
          locationCart.amount,
          (locationCart.products || []).length,
        ].join(':');
      } catch (e) {
        return '';
      }
    }

    // Prefer the product in the same category pane as on the slave, then any pane, then the hidden copy
    function findTile(data) {
      const byKey = function () {
        return dualTileKey($(this)) === data.key;
      };
      const $sameCategory = dualTiles(dualPane(String(data.categoryId || DUAL_ALL_CATEGORY))).filter(byKey);
      if ($sameCategory.length) {
        return $sameCategory.first();
      }
      const $anywhere = $('#product-list .category-tabcontent .shop-product-container, #dual-screen-product-buffer .shop-product-container').filter(byKey);
      return $anywhere.length ? $anywhere.first() : null;
    }

    // The slave lists every product, the master only its current page: keep a hidden copy of all of them
    function loadProductBuffer() {
      dualLoadAllProducts(DUAL_ALL_CATEGORY).then(function (html) {
        let $buffer = $('#dual-screen-product-buffer');
        if (!$buffer.length) {
          $buffer = $('<div id="dual-screen-product-buffer" hidden></div>').appendTo('body');
        }
        $buffer.html(html);
      });
    }

    function handleTap(data) {
      const tapId = String(data.tapId || '');
      if (!tapId || handledTapIds.indexOf(tapId) !== -1) {
        return;
      }
      handledTapIds.push(tapId);
      if (handledTapIds.length > 200) {
        handledTapIds.shift();
      }

      const ack = function (result, message) {
        connection.send({ type: 'dual.tap_ack', tapId: tapId, result: result, message: message || '' });
      };

      if (locked || slaveHidden) {
        ack('rejected', messages.locked);
        return;
      }
      if ($('.modal.show').length) {
        ack('busy', messages.busy);
        return;
      }
      const $tile = findTile(data);
      if (!$tile) {
        sendState(true);
        ack('rejected', messages.stale);
        return;
      }

      const before = cartSnapshot();
      const $subCategory = $tile.find('.sub_product_category_card_btn');
      if ($subCategory.length) {
        $subCategory.trigger('click.subCategory');
      } else {
        const $add = $tile.find('.add-product').first();
        if (!$add.length) {
          ack('rejected', messages.not_added);
          return;
        }
        $add.trigger('click');
      }

      // Added at once, or a modal (extras, weight, open price) opens here on the master
      const start = Date.now();
      (function check() {
        if (cartSnapshot() !== before) {
          ack('added');
        } else if ($('.modal.show').length) {
          ack('modal', messages.continue_on_master);
        } else if (Date.now() - start > 600) {
          ack('done');
        } else {
          setTimeout(check, 30);
        }
      })();
    }

    // Show or hide products on the slave; hidden leaves the slave with only its header
    const $slaveToggle = $('#dual-screen-slave-toggle');
    function renderSlaveToggle() {
      $slaveToggle
        .toggleClass('dual-slave-on', !slaveHidden)
        .find('.dual-screen-slave-toggle-label')
        .text($slaveToggle.attr(slaveHidden ? 'data-label-off' : 'data-label-on'));
    }
    $slaveToggle.on('click', function () {
      slaveHidden = !slaveHidden;
      try {
        localStorage.setItem('dualScreenSlaveHidden', slaveHidden ? '1' : '0');
      } catch (e) {}
      renderSlaveToggle();
      refresh(true);
    });
    renderSlaveToggle();

    loadProductBuffer();

    // Product group chosen here: the slave shows that group (selectCategory() already ran from the inline onclick)
    $(document).on('click', '.tablinks', function () {
      refresh(false);
    });

    // PIN out: blank the slave before the PIN screen loads
    $(document).on('click', 'a[href*="/user/organizer_login"]', function () {
      locked = true;
      refresh(true);
    });

    connection.connect();
  }

  /**
   * Slave: shows the product group chosen on the master ("all" at first) as one scrolling list
   * and sends product taps to the master instead of adding to its own cart.
   */
  function initDualSlave($pos, messages) {
    const $status = $('#dual-screen-status');
    const pendingTaps = {};
    let masterName = '';
    let lastState = null;

    function setBlank(text) {
      $pos.addClass('dual-blank').toggleClass('dual-show-status', !!text);
      $status.text(text || '');
    }

    // One message for every state out of sync with the master (connecting, offline, PIN out, switched off)
    function notSyncedText() {
      return (messages.not_synced || '').replace('{master}', masterName);
    }

    const connection = createDualConnection({
      onInfo: function (data) {
        masterName = data.master_name || '';
        setBlank(notSyncedText());
      },
      onUnpaired: function () {
        setBlank(messages.no_master);
      },
      onMessage: function (data) {
        switch (data.type) {
          case 'dual.welcome':
            if (data.peerOnline) {
              connection.send({ type: 'dual.request_state' });
            } else {
              setBlank(notSyncedText());
            }
            break;
          case 'dual.peer':
            if (data.online) {
              connection.send({ type: 'dual.request_state' });
            } else {
              lastState = null;
              setBlank(notSyncedText());
            }
            break;
          case 'dual.state':
            applyState(data);
            break;
          case 'dual.tap_ack':
            finishTap(data.tapId, data.result, data.message);
            break;
        }
      },
      onDisconnected: function () {
        lastState = null;
        setBlank(notSyncedText());
        Object.keys(pendingTaps).forEach(function (tapId) {
          finishTap(tapId, 'timeout');
        });
      },
    });

    // Each category becomes one scrolling list with every product, loaded once
    const fullListLoaded = {};
    let shownCategory = null;

    function loadFullList(categoryId) {
      if (fullListLoaded[categoryId]) {
        return;
      }
      fullListLoaded[categoryId] = true;
      dualLoadAllProducts(categoryId).then(function (html) {
        if (html) {
          dualPane(categoryId).html(html);
        } else {
          fullListLoaded[categoryId] = false;
        }
      });
    }

    // The category panes arrive with the POS's own product request; wait for them if needed
    function showCategory(categoryId, attempt) {
      if (!$('#category-tabcontent-' + categoryId).length) {
        if ((attempt || 0) < 40) {
          setTimeout(function () {
            if (lastState && String(lastState.categoryId || DUAL_ALL_CATEGORY) === categoryId) {
              showCategory(categoryId, (attempt || 0) + 1);
            }
          }, 250);
        }
        return;
      }
      $('.tabcontent').hide();
      $('#category-tabcontent-' + categoryId).css('display', 'block').scrollTop(0);
      $('.tablinks').removeClass('active');
      $('#category-' + categoryId + '-tab').addClass('active');
      shownCategory = categoryId;
      loadFullList(categoryId);
    }

    function applyState(state) {
      lastState = state;

      if (state.locked || state.hidden) {
        setBlank(notSyncedText());
        return;
      }
      if (String(state.locationId) !== String($('#location-id').val())) {
        // Follow the master to its location
        try {
          if (sessionStorage.getItem('dualScreenFollowUrl') === state.posUrl) {
            setBlank(notSyncedText());
            return;
          }
          sessionStorage.setItem('dualScreenFollowUrl', state.posUrl);
        } catch (e) {}
        window.location.href = state.posUrl;
        return;
      }
      try {
        sessionStorage.removeItem('dualScreenFollowUrl');
      } catch (e) {}

      const categoryId = String(state.categoryId || DUAL_ALL_CATEGORY);
      if (categoryId !== shownCategory || $pos.hasClass('dual-blank')) {
        showCategory(categoryId);
      }
      $pos.removeClass('dual-blank dual-show-status');
    }

    function sendTap($tile) {
      if (!lastState || $pos.hasClass('dual-blank')) {
        return;
      }

      const tapId = dualUuid();
      $tile.addClass('dual-tap-pending');
      pendingTaps[tapId] = {
        $tile: $tile,
        timer: setTimeout(function () {
          finishTap(tapId, 'timeout');
        }, DUAL_TAP_ACK_TIMEOUT),
      };

      const sent = connection.send({
        type: 'dual.tap',
        tapId: tapId,
        categoryId: shownCategory,
        key: dualTileKey($tile),
      });
      if (!sent) {
        finishTap(tapId, 'timeout');
      }
    }

    function finishTap(tapId, result, message) {
      const pending = pendingTaps[tapId];
      if (!pending) {
        return;
      }
      delete pendingTaps[tapId];
      clearTimeout(pending.timer);

      const ok = result === 'added' || result === 'done' || result === 'modal';
      const flashClass = ok ? 'dual-tap-ok' : 'dual-tap-fail';
      pending.$tile.removeClass('dual-tap-pending').addClass(flashClass);
      setTimeout(function () {
        pending.$tile.removeClass(flashClass);
      }, ok ? 300 : 1200);

      if (result === 'modal' || !ok) {
        showToast({
          type: ok ? 'info' : 'error',
          title: '',
          message: message || messages.not_added,
          position: 'bottom-center',
          duration: 2500,
        });
      }
    }

    // Product taps go to the master: stop the tile's own handlers (cart, long press, hold to confirm)
    // in the capture phase. Scrolling and the page buttons keep working.
    const productList = document.getElementById('product-list');
    if (productList) {
      const onTile = function (e) {
        return e.target.closest && e.target.closest('.shop-product-container');
      };
      ['touchstart', 'touchend', 'mousedown', 'mouseup', 'dblclick', 'contextmenu'].forEach(function (type) {
        productList.addEventListener(type, function (e) {
          if (onTile(e)) {
            e.stopPropagation();
          }
        }, true);
      });
      productList.addEventListener('click', function (e) {
        const tile = onTile(e);
        if (!tile) {
          return;
        }
        e.stopPropagation();
        e.preventDefault();
        sendTap($(tile));
      }, true);
    }

    connection.connect();
  }
})();
